import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from './CTAButton';
import { PRICE } from './salesData';
import { trackInitiateCheckout } from '../utils/metaPixel';

/**
 * Barra fija de compra para móvil. Aparece después del primer scroll y se
 * esconde cuando la sección de oferta ya está visible (para no taparla).
 */
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const scrolled = window.scrollY > 520;
      const offer = document.getElementById('comprar');
      const offerVisible = offer ? offer.getBoundingClientRect().top < window.innerHeight - 80 && offer.getBoundingClientRect().bottom > 0 : false;
      setVisible(scrolled && !offerVisible);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-50 border-t border-gold/25 bg-ink/95 backdrop-blur transition-[transform,opacity] duration-200 ease-out ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'}`} data-id="element-158" data-mp="29ezir2gaw8ba">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-3" data-id="element-159" data-mp="2idkyyqyavb8w">
        <div className="min-w-0" data-id="element-160" data-mp="2n88omt51ibp2">
          <p className="font-display text-[0.58rem] uppercase tracking-editorial text-ash" data-id="element-161" data-mp="2s5qta7c0y4r9">
            6 tomos · 500 recetas · 5 bonos
          </p>
          <p className="mt-0.5 flex items-baseline gap-2" data-id="element-162" data-mp="2x2h8ksg08wbm">
            <span className="text-[0.78rem] text-ash line-through" data-id="element-163" data-mp="3235862iaulhg">{PRICE.previous}</span>
            <span className="font-condensed text-xl leading-none text-gold" data-id="element-164" data-mp="365i9meq0jx8f">{PRICE.current}</span>
          </p>
        </div>
        <a href={CHECKOUT_URL} onClick={() => trackInitiateCheckout()} className="inline-flex min-h-[48px] shrink-0 items-center gap-2 rounded-lg bg-gold px-5 py-3 font-display text-[0.72rem] uppercase tracking-[0.02em] text-ink transition-colors duration-150 ease-out hover:bg-gold-hot focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 sm:text-[0.82rem]" data-id="element-165" data-mp="17qp3v792dhf8">
          Comprar ahora
          <ArrowRightIcon className="h-4 w-4" aria-hidden strokeWidth={2.75} data-id="element-166" data-mp="2o08a6gnw0zg6" />
        </a>
      </div>
    </div>;
}